export default __webpack_public_path__ + "static/media/brand.e6a0757c.png";